import React from "react";

export default function Services() {
  return (
    <section id="services" className="services">
      <div className="container">
        <div className="section-header">
          <h2>Our Services</h2>
          <p className="section-subtitle">
            Comprehensive solar solutions for every need
          </p>
        </div>
        <div className="services-grid">
          <div className="service-card service-card--residential">
            <div className="service-icon">🏠</div>
            <h3>Residential Solar Installation</h3>
            <p>Complete solar solutions for homes including rooftop panels</p>
          </div>
          <div className="service-card service-card--industrial">
            <div className="service-icon">🏭</div>
            <h3>Industrial Solar Systems</h3>
            <p>Large-scale solar installations for industries</p>
          </div>
          <div className="service-card service-card--grid">
            <div className="service-icon">🔋</div>
            <h3>Off-Grid Solar Solutions</h3>
            <p>Independent solar systems with battery storage</p>
          </div>
          <div className="service-card service-card--grid">
            <div className="service-icon">🔌</div>
            <h3>On-Grid Solar Systems</h3>
            <p>Grid-tied solar systems that sell excess power back</p>
          </div>
        </div>
      </div>
    </section>
  );
}
